import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { createContext, useContext } from 'react';

export type PillDragContextValueType = {
  attributes: DraggableAttributes;
  listeners: SyntheticListenerMap | undefined;
  setActivatorNodeRef: (element: HTMLElement | null) => void;
  isDragging: boolean;
};

const PillDragContext = createContext<PillDragContextValueType | null>(null);

type PillDragProviderPropsType = {
  value: PillDragContextValueType;
  children: React.ReactNode;
};

export const PillDragProvider: React.FC<PillDragProviderPropsType> = ({
  value,
  children,
}) => (
  <PillDragContext.Provider value={value}>{children}</PillDragContext.Provider>
);

export const usePillDrag = (): PillDragContextValueType | null =>
  useContext(PillDragContext);
